import { Navigate, Outlet } from 'react-router-dom'

import NotFound from 'modules/core/components/NotFound'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { usePerformanceModuleContext } from 'modules/performance/hooks/usePerfomanceModuleContext'
import CollectionsBootstrap from 'modules/reviews/lib/PerformanceCollectionsBootstrap'

const Container = () => {
  const { navigation } = useNavigation()

  const { performanceFeatureAvailability, hasFullVisibility } = usePerformanceModuleContext()
  const canSeeReview = performanceFeatureAvailability.canSeeReviews

  if (!canSeeReview && hasFullVisibility)
    return <Navigate replace to={navigation.appStore.fullPath()} />

  if (!canSeeReview || performanceFeatureAvailability.errorReviewSetup) return <NotFound />

  return <Outlet />
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
